import {create} from 'zustand'

type BugReporterStore = {
    isOpen: boolean
    open: () => void
    close: () => void
}

export const useBugReporterStore = create<BugReporterStore>()(set => ({
    isOpen: false,
    open: () => set({isOpen: true}),
    close: () => set({isOpen: false})
}))
